module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sin"
  }, [_c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.text) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.text.SIN[0].text)
    }
  }) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.update()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.legalName),
      expression: "legalName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Full Legal Name"
    },
    domProps: {
      "value": (_vm.legalName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.legalName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Do You Have a Canadian SIN #?")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasSin),
      expression: "hasSin"
    }],
    attrs: {
      "id": "no_sin",
      "value": "false",
      "name": "has_sin",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.hasSin, "false")
    },
    on: {
      "__c": function($event) {
        _vm.hasSin = "false"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "check-label",
    attrs: {
      "for": "no_sin"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasSin),
      expression: "hasSin"
    }],
    attrs: {
      "id": "yes_sin",
      "value": "true",
      "name": "has_sin",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.hasSin, "true")
    },
    on: {
      "__c": function($event) {
        _vm.hasSin = "true"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "check-label",
    attrs: {
      "for": "yes_sin"
    }
  }, [_vm._v("Yes")])])]), _vm._v(" "), (_vm.hasSin == 'true') ? _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sin),
      expression: "sin"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Canadian SIN #"
    },
    domProps: {
      "value": (_vm.sin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sin = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Government Required Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00e2f59e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SIN.vue
// module id = 1935
// module chunks = 2